import { ComparisonTableProps } from '@eika/comparison-table/lib/ComparisonTableTypes';

import { hyphenAsSoftHyphen } from '../../utils/hyphenAsSoftHyphen';
import { spaceToNBSP } from '../../utils/spaceToNBSP';

const hestConfig: ComparisonTableProps = {
    tableHeadColumns: [
        {
            title: 'Ansvar',
            description: '',
        },
    ],
    rows: [
        {
            title: 'Liv',
            checkedRows: 1,
            help: 'Gir erstatning viss hesten din døyr eller blir borte. Dekkjer også utgiftene viss hesten må avlivast på grunn av ulykke eller skade.',
        },
        {
            title: `${hyphenAsSoftHyphen('Veterinær-utgifter')}`,
            checkedRows: 1,
            help: 'Dekkjer veterinærutgiftene til hesten.',
        },
        {
            title: `${hyphenAsSoftHyphen('Nød-slakt')}`,
            checkedRows: 1,
            help: `Viss hesten døyr eller må avlivast ertsatter me utgifter til nødslakt, bortkøyring og destruksjon av kadaver med inntil ${spaceToNBSP(
                '3 000',
            )} kroner.`,
        },
    ],
};

export default hestConfig;
